/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import Main from '../../../components/HOC/Main';
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import Button from '../../../components/common/Button';
import CustomTable from '../../../components/common/CustomTable';
import { selectSelectedFonts, setSelectedFonts, toggleCommonDeleteModal, toggleFontsSlide } from '../../../store/slices/common';
import { FaPlus } from 'react-icons/fa';
import TableAction from '../../../components/TableAction';
import { clearFontsData, deleteFonts, fetchFonts, selectFontsData, setFontsData } from '../../../store/slices/api/inner/fontsSlice';
import FontsForm from '../../../components/pages/FontsForm';

export const FontsPage = () => {
  const dispatch = useDispatch();
  const fontsData = useSelector(selectFontsData);
  const selectedFonts = useSelector(selectSelectedFonts)

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchFonts,
    setValueAction: setFontsData,
    clearValueActionOnError: clearFontsData,
    isForm: false,
    successMessage: false,
  });

    // delete start
    const openDeleteModal = (data) => {
      dispatch(setSelectedFonts(data))
      dispatch(toggleCommonDeleteModal())
    }
    const cancelDeleteModal = () => {
      dispatch(setSelectedFonts(null))
      dispatch(toggleCommonDeleteModal())
    }
 
    const afterAPICall = (res) => {
      fetchData()
      dispatch(toggleCommonDeleteModal())
    }
  
    const { handleSubmit: handleDelete } = useApiRequest({
      apiAction: deleteFonts,
      isForm: false,
      afterAPICall,
    });
    // delete end

  const handleEdit = (data) => {
    dispatch(setSelectedFonts(data));
    dispatch(toggleFontsSlide());
  }

  const handleAdd = () => {
    dispatch(setSelectedFonts(null));
    dispatch(toggleFontsSlide())
  }

  const columns = useMemo(() => [

    {
      accessorKey: 'font_name',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"font name"
    },
    {
      accessorKey: 'font_family',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
      header:"font family"
    },

    {
      id: 'actions',
      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "settings" }, { title: "fonts" }]}  handleDelete={() => {handleDelete({ fontId: selectedFonts.font_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={fontsData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add Fonts</Button>} />
      <FontsForm defaultData={selectedFonts} fetchData={fetchData} />
    </Main>
  );
};
